import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiTrendingUp, FiFileText, FiBriefcase } from 'react-icons/fi';

const ServicesSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const serviceItems = [
    {
      icon: <FiTrendingUp className="w-12 h-12 text-blue-600" />,
      title: "Wealth Management Services",
      description: "Personal / Business Retirement Accounts. 401(k) Rollovers. Online Access Available. Wealth Management / Retirement Planning. College Planning. Estate Planning.",
      image: "https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/64d5563664f56aacaf657003_wealthmanagementicon.png"
    },
    {
      icon: <FiFileText className="w-12 h-12 text-blue-600" />,
      title: "Tax Preparation Services",
      description: "Personal or Business Income Tax Preparation. Audit Protection Services. Tax Planning / Consultations. Remote, In-Person, or Drop-Off Available. We also partner with Refund Advantage to offer various bank products to tax clients upon request (details on site).",
      image: "https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/64d55650ed82aea1b4c1ec04_icon-taxpreparation.png"
    },
    {
      icon: <FiBriefcase className="w-12 h-12 text-blue-600" />,
      title: "Additional Services",
      description: "Complimentary Notary Services for all Clients. Active Wealth Management Clients are eligible for a complimentary & detailed written Financial Plan upon request, so that you can stay on track with your investment objectives. Active Wealth Management clients are also eligible for our Financial Coaching program via Ramsey Solutions & our resource portal at no cost. (+ More)...",
      image: "https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/64d55b1c3eb0f9648b48a16c_otherservices.jpg"
    }
  ];

  return (
    <section id="services" className="py-20 bg-white" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="lg:sticky lg:top-32"
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Services</h2>
            <p className="text-lg text-gray-700 mb-8">
              We understand that no two clients are the same. The goal, as experienced & knowledgeable tax & financial professionals, is to design strategies developed specifically for your own unique situation. Those strategies will help you reach your financial goals, while securing the maximum possible tax benefit.
            </p>
            <img 
              src="https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/65297a779d286e574ce3f409_Financial%20Plan%20Example.png" 
              alt="Financial Plan Example" 
              className="rounded-lg shadow-lg w-full max-w-md mx-auto"
            />
          </motion.div>

          <div className="space-y-12">
            {serviceItems.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                className="flex flex-col md:flex-row gap-6 items-start"
              >
                <div className="w-20 h-20 flex-shrink-0 bg-blue-100 rounded-lg p-4 flex items-center justify-center">
                  <img src={service.image} alt={service.title} className="max-w-full max-h-full" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
                  <p className="text-gray-700">{service.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;